/* eslint-disable */
import dayjs from 'dayjs';

// eslint-disable-next-line camelcase
import de_DE from 'dayjs/locale/de';
// eslint-disable-next-line camelcase
import en_EN from 'dayjs/locale/en';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { format } from 'quasar';

dayjs.extend(relativeTime);

dayjs.extend(timezone);
dayjs.extend(utc);

const locales = {
  en_EN,
  en: en_EN,
  en_US: en_EN,
  de_DE,
};

export const getDateTz = (value) => dayjs(value * 1000).tz(dayjs.tz.guess());
export const getTimestamp = (value) => dayjs(value).unix();
export const formatDate = (value, dateFormat, locale = 'en_EN') => {
  return dayjs(value).locale(locales[locale]).format(dateFormat);
};

export const formatUTCDate = (value, dateFormat, locale = 'en_EN') => {
  return dayjs(value).utc().locale(locales[locale]).format(dateFormat);
};

export const isDateInPast = (date) => dayjs(date).isBefore(dayjs());

/**
 * @param {number} sec
 * @returns {string}
 */
export const convertSecondsToDuration = (sec) => {
  const minutes = format.pad(Math.floor((sec % (60 * 60)) / 60), 2);
  const seconds = format.pad(Math.floor(sec % 60), 2);
  return `${minutes}:${seconds}`;
};

export const fromNow = (timestamp, locale = 'en_EN') => {
  const date = dayjs.unix(timestamp);
  return dayjs(date).locale(locales[locale]).fromNow();
};
